import React from 'react';

const FormCheckbox = ({
  id,
  name,
  label,
  checked,
  onChange,
  error,
  required = false,
  disabled = false,
}) => {
  const fieldId = id || name;
  const errorId = error ? `${fieldId}-error` : undefined;

  return (
    <div className={`tf-checkbox${error ? ' tf-checkbox--invalid' : ''}`}>
      <label className="tf-checkbox__row" htmlFor={fieldId}>
        <input
          id={fieldId}
          name={name}
          type="checkbox"
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
          required={required}
          aria-invalid={!!error}
          aria-required={required || undefined}
          aria-describedby={errorId}
          className="tf-checkbox__input"
        />
        <span className="tf-checkbox__box" aria-hidden="true" />
        <span className="tf-checkbox__label">
          {label}{required && <span aria-hidden="true" className="tf-field__required"> *</span>}
        </span>
      </label>
      {error && (
        <span id={errorId} className="tf-field__error" role="alert">{error}</span>
      )}
    </div>
  );
};

export default FormCheckbox;
